/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;height:100%}.popover-title[_ngcontent-%COMP%]{width:100%;padding:.25rem;display:flex;flex-direction:row;align-items:center;justify-content:center}.popover-title-text[_ngcontent-%COMP%]{font-size:.9rem}.popover-title-icon[_ngcontent-%COMP%]{position:fixed;right:.5rem}.center-aligned[_ngcontent-%COMP%]{text-align:center;max-width:250px}.bordered-top[_ngcontent-%COMP%]{border-top:1px solid;padding-top:.5rem}"];
export { styles as styles };
